import { atom } from 'jotai';

// 用于高亮属性关联的跳题逻辑
export const $highlightProperty = atom<string | null>(null);
